// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export class CtsGantryScrollPaginationModel {
  public constructor(
    public totalElements = 0,
    public pageSize = 15,
    public pageIndex = 0,
    public updatePageFn: (start: number, end: number) => void = () => {},
  ) {}

  public onScrollEnd = (): void => {
    const start = (this.pageIndex + 1) * this.pageSize;
    const end = Math.min(start + this.pageSize, this.totalElements);

    if (start < end) {
      this.updatePageFn(start, end);
      this.pageIndex++;
    }
  }
}
